import { interjectResourceString } from './interjectResourceString';
export function getCardOperatedByText(leg, resourceStrings) {
    var _a;
    const operatingAirlines = [];
    (_a = leg.segments) === null || _a === void 0 ? void 0 : _a.forEach((segment) => {
        var _a, _b;
        const operatingAirlineName = ((_a = segment === null || segment === void 0 ? void 0 : segment.operatingAirline) === null || _a === void 0 ? void 0 : _a.name) || '';
        if (operatingAirlineName &&
            ((_b = segment === null || segment === void 0 ? void 0 : segment.airline) === null || _b === void 0 ? void 0 : _b.name) !== operatingAirlineName &&
            !operatingAirlines.includes(operatingAirlineName)) {
            operatingAirlines.push(operatingAirlineName);
        }
    });
    switch (operatingAirlines === null || operatingAirlines === void 0 ? void 0 : operatingAirlines.length) {
        case 1:
            return interjectResourceString(resourceStrings.OPERATED_BY_CARRIER_PROMPT, Object.assign({}, operatingAirlines));
        case 2:
            return interjectResourceString(resourceStrings.OPERATED_BY_TWO_CARRIERS_PROMPT, Object.assign({}, operatingAirlines));
        case 3:
            return interjectResourceString(resourceStrings.OPERATED_BY_THREE_CARRIERS_PROMPT, Object.assign({}, operatingAirlines));
        default:
            return null;
    }
}
